export default [
    {
        path: '/party',
        name: 'Party',
        component: () => import('../../views/Dangjian.vue')
    },
    {
        path: '/party/:id',
        name: 'PartyDetail',
        props: true,
        component: () => import('../../views/DangjianDetail.vue')
    }
]
